const defaultItemSearchFields = [
    "itemCd",
    "itemName",
]

const itemDescSearchFields = [
    "descTxt",
]

const itemInvClassCdSearchFields = [
    "invClassCd"
]

const itemHrchySearchFields = [
    "itemHrchyLevel1",
    "itemHrchyLevel2",
    "itemHrchyLevel3",
    "itemHrchyLevel4",
    "itemHrchyLevel5",
    "itemHrchyLevel6",
    "itemHrchyLevel7",
    "itemHrchyLevel8",
    "itemHrchyLevel9",
    "itemHrchyLevel10"
]

const itemAttributeSearchFields = [
    "attr01",
    "attr02",
    "attr03",
    "attr04",
    "attr05",
    "attr06",
    "attr07",
    "attr08",
    "attr09",
    "attr10",
]

const defaultCustomerSearchFields = [
    "customerCd",
    "customerName",
]

const customerHrchySearchFields = [
    "customerHrchyLevel1",
    "customerHrchyLevel2",
    "customerHrchyLevel3",
    "customerHrchyLevel4",
    "customerHrchyLevel5",
    "customerHrchyLevel6",
    "customerHrchyLevel7",
    "customerHrchyLevel8",
    "customerHrchyLevel9",
    "customerHrchyLevel10"
]

const customerDescSearchFields = [
    "descTxt",
]

const CustomerAttributeSearchFields = [
    "attr01",
    "attr02",
    "attr03",
    "attr04",
    "attr05",
    "attr06",
    "attr07",
    "attr08",
    "attr09",
    "attr10",
    "attr11",
    "attr12",
    "attr13",
    "attr14",
    "attr15",
    "attr16",
    "attr17",
    "attr18",
    "attr19",
    "attr20",
]

// 추후 params를 json stringfiy 할떄 필요.
// const setItemDetailParams = (params, itemDetails) => {
//     if(!isEmpty(itemDetails)) {
//         params.itemDetails = JSON.stringify(itemDetails);
//     }
// }

const ElasticSearchUtil = {
    defaultItemSearchFields,
    itemDescSearchFields,
    itemInvClassCdSearchFields,
    itemHrchySearchFields,
    itemAttributeSearchFields,
    defaultCustomerSearchFields,
    customerDescSearchFields,
    customerHrchySearchFields,
    CustomerAttributeSearchFields,
};

export default ElasticSearchUtil;